import {Component, OnInit} from '@angular/core';
import {ObjectBaseModeComponent} from '../../../../../../core/shared/object/mvs-object-base/object-base-mode.component';

@Component({
    selector: 'bm-billing-area-base',
    template: '',
    standalone: false
})
export class BmBillingAreaBaseComponent extends ObjectBaseModeComponent implements OnInit {

    navigationItems = [
        {
            label: 'Abrechnungsbereich',
            action: 'billingArea',
            tooltip: 'Abrechnungsbereich Details',
            icon: 'fa-solid fa-layer-group',
            toggleable: false,
            default: true
        },
        {
            label: 'Bereichspartner',
            action: 'billingAreaPartner',
            tooltip: 'Bereichspartner',
            icon: 'fa-solid fa-users',
            toggleable: false,
            default: false
        },
        {
            label: 'Abrechnungslauftypen',
            action: 'billingRunType',
            tooltip: 'Abrechnungslauftypen',
            icon: 'fa-solid fa-play',
            toggleable: false,
            default: false
        },
        {
            label: 'Zahlungserinnerungstypen',
            action: 'paymentReminderType',
            tooltip: 'Zahlungserinnerungstypen',
            icon: 'fa-solid fa-file-invoice',
            toggleable: false,
            default: false
        },
        // TM-1000002058: configuration of the premium change notice of the area (bm.PremiumChangeNoticeType)
        {
            label: 'Beitragsänderungs-Information',
            action: 'premiumChangeNoticeType',
            tooltip: 'Beitragsänderungs-Information',
            icon: 'fa-solid fa-envelope-open-text',
            toggleable: false,
            default: false
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

}
